import Vue from 'vue'
import Vuex from 'vuex'
import filters from './modules/filters'
import settings from './modules/settings'
import persistedState from './plugins/persistedState'
import firestore from './plugins/firestore'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [persistedState, firestore],
  state: {
    isLoading: true,
    user: null,
    shits: [],
    projects: [],
    contexts: [],
    mentions: [],
    mits: [],
    bigRocks: []
  },
  getters: {
    mits: state => {
      return state.mits
    },
    bigRocks: state => {
      return state.bigRocks
    },
    projects: state => {
      return state.projects
    },
    contexts: state => {
      return state.contexts
    },
    mentions: state => {
      return state.mentions
    },
    shits: state => {
      return state.shits
    },
    shit: state => uuid => {
      return state.shits.find(s => s.uuid === uuid)
    },
    openShits: state => {
      return state.shits.filter(s => s.completedAt === null && s.description)
    },
    collectedShits: state => {
      return state.shits.filter(s => s.completedAt === null && s.description && !('action' in s))
    },
    processedShits: state => {
      return state.shits.filter(s => {
        return s.completedAt === null && (['next', 'mentions'].includes(s.action) || !('action' in s))
      })
    },
    plannedShits: state => {
      return state.shits.filter(s => ['next', 'mentions'].includes(s.action))
    },
    hasUser: state => {
      return state.user !== null
    },
    userFirstName: state => {
      return state.user ? state.user.displayName.split(' ')[0] : 'Anon'
    },
    isLoading: state => {
      return state.isLoading
    }
  },
  mutations: {
    deleteShit (state, shit) {
      const index = state.shits.findIndex(s => s.uuid === shit.uuid)
      state.shits.splice(index, 1)
    },
    admitShit (state, { shit, after }) {
      let oldShit = state.shits.find(s => s.uuid === shit.uuid)

      if (oldShit === undefined) {
        shit.createdAt = new Date()
        if (after) {
          const afterIndex = state.shits.findIndex(s => s.uuid === after.uuid)
          state.shits.splice(afterIndex + 1, 0, shit)
        } else {
          state.shits.push(shit)
        }
        oldShit = shit
      } else {
        shit.updatedAt = new Date()
        Object.assign(oldShit, shit)
      }

      state.projects = [...new Set([...state.projects, ...oldShit.projects])]
      state.contexts = [...new Set([...state.contexts, ...oldShit.contexts])]
      state.mentions = oldShit.mentions ? [...new Set([...state.mentions, ...oldShit.mentions])] : state.mentions
    },
    setUser (state, user) {
      state.user = user
    },
    toggleBigRock (state, shit) {
      const idx = state.bigRocks.indexOf(shit.uuid)
      if (idx === -1) {
        state.bigRocks.push(shit.uuid)
      } else {
        state.bigRocks.splice(idx, 1)
      }
    },
    toggleMit (state, shit) {
      const idx = state.mits.indexOf(shit.uuid)
      if (idx === -1) {
        state.mits.push(shit.uuid)
      } else {
        state.mits.splice(idx, 1)
      }
    },
    setBigRocks (state, shitUuids) {
      state.bigRocks = shitUuids
    },
    // firebase mutations
    hydrateShit (state, newShit) {
      const oldShit = state.shits.find(s => s.uuid === newShit.uuid)

      if (oldShit !== undefined) {
        Object.assign(oldShit, newShit)
        state.projects = [...new Set([...state.projects, ...oldShit.projects])]
        state.contexts = [...new Set([...state.contexts, ...oldShit.contexts])]
        state.mentions = [...new Set([...state.mentions, ...oldShit.mentions])]
      }
    },
    downloadShit (state, shit) {
      state.shits.push(shit)
    },
    dropShit (state, shit) {
      const index = state.shits.findIndex(s => s.uuid === shit.uuid)
      if (index !== -1) {
        state.shits.splice(index, 1)
      }
    },
    hydrateShits (state, shits) {
      state.shits = shits
    },
    hydrateProjects (state, projects) {
      state.projects = projects
    },
    hydrateContexts (state, contexts) {
      state.contexts = contexts
    },
    hydrateMentions (state, mentions) {
      state.mentions = mentions
    },
    setLoaded (state) {
      state.isLoading = false
    }
  },
  actions: {
    insertEmptyShitAfter ({ commit, state }, after) {
      // @todo dupes
      const uuidv4 = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
      }

      const shit = {
        description: null,
        completedAt: null,
        uuid: uuidv4(),
        projects: state.filters.selectedProjects,
        contexts: state.filters.selectedContexts,
        mentions: state.filters.selectedMentions
        // action
        // schedule
      }

      commit('admitShit', { shit, after })

      // priority
      // @todo shit-priority-types
      if (state.filters.selectedPriority === 'today') {
        commit('toggleMit', shit)
      } else if (state.filters.selectedPriority === 'this week') {
        commit('toggleBigRock', shit)
      }

      return Promise.resolve(shit)
    },
    appendEmptyShit ({ commit, state }) {
      // @todo dupes
      const uuidv4 = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
      }

      const shit = {
        description: null,
        completedAt: null,
        uuid: uuidv4(),
        projects: state.filters.selectedProjects,
        contexts: state.filters.selectedContexts,
        mentions: state.filters.selectedMentions
      }

      commit('admitShit', { shit })
      return Promise.resolve(shit)
    },
    deleteShit ({ commit }, shit) {
      commit('deleteShit', shit)
    },
    syncShit ({ commit }, shit) {
      commit('admitShit', { shit })
    },
    setCurrentUser ({ commit }, user) {
      commit('setUser', user)
    }
  },
  modules: {
    filters,
    settings
  }
})
